import {Brick, registerBrick, Service} from 'olympe';

export default class FakeSubscribe extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} userId
     * @param {string} userFullName
     * @param {string} frontendId
     * @param {function()} forwardEvent
     * @param {function(Object)} setDataReceived
     */
    update($, [userId, userFullName, frontendId], [forwardEvent, setDataReceived]) {
        const {observable} = Service.observe('userService', $,
            {userId: userId,
                userFullName: userFullName,
                frontendId: frontendId});

        observable.subscribe((data) => {
            setDataReceived(data);
            forwardEvent();
        });
    }
}

registerBrick('0198ccaaa9bb7c31aada', FakeSubscribe);
